export default __webpack_public_path__ + "static/media/pendingorders.3b962d1e.svg";